import type { CityConfig } from "../city-template/types";

export const bayCityConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Bay County Clerk", href: "https://www.baycounty-mi.gov/clerk", description: "Bay County Clerk — marriage license issuance" },
    { label: "Divorce Records — Bay County Clerk", href: "https://www.baycounty-mi.gov/clerk", description: "Bay County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Bay City",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "bay-city",
  route: "/cities/bay-city",
  title: "Emergency Passport Bay City, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Bay City, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Bay City, Essexville, Auburn, Linwood, and all Bay County residents. Saginaw Bay and Lake Huron coverage. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Bay City, MI",
  heroSubtitle: "Bay City travelers — Saginaw Bay residents, Lake Huron coastal communities, MBS International Airport flyers, and international families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Bay County and the Great Lakes Bay region.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Bay%20City%20Michigan%20downtown%20and%20Saginaw%20Bay%20waterfront%2C%20historic%20buildings%2C%20modern%20marina%2C%20lush%20green%20trees%2C%20Lake%20Huron%20coastline%2C%20warm%20golden%20hour%20light%2C%20clear%20blue%20sky%2C%20no%20text%20no%20people%2C%20cinematic%20landscape%20photography&width=1800&height=700&seq=baycity-hero-001&orientation=landscape",
  heroImageAlt: "Bay City Michigan downtown and Saginaw Bay waterfront at golden hour",
  geoPosition: "43.5945;-83.8889",
  geoPlacename: "Bay City, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 115 miles southeast of Bay City — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Bay City", zips: "48706, 48707, 48708, 48710" },
    { name: "Essexville", zips: "48732" },
    { name: "Auburn", zips: "48611" },
    { name: "Linwood", zips: "48634" },
    { name: "Pinconning", zips: "48650" },
    { name: "Kawkawlin", zips: "48631" },
    { name: "Bangor Township", zips: "48706" },
    { name: "Monitor Township", zips: "48706" },
    { name: "Frankenlust Township", zips: "48706" },
    { name: "Hampton Township", zips: "48708" },
    { name: "Portsmouth Township", zips: "48710" },
    { name: "Saginaw", zips: "48601, 48602, 48603, 48604, 48605, 48607" },
    { name: "Midland", zips: "48640, 48641, 48642, 48667, 48670" },
    { name: "Freeland", zips: "48623" },
    { name: "Frankenmuth", zips: "48734, 48787" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "Great Lakes Bay Expertise", desc: "Saginaw Bay, Lake Huron, and MBS International Airport travel passport support" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from anywhere in Bay County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Saginaw, MI", route: "/cities/saginaw" },
    { name: "Emergency passport services in Midland, MI", route: "/cities/midland" },
    { name: "Urgent passport services in Flint, MI", route: "/flint" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Bay City, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the 115-mile drive or appointment wait. Bay City residents can ship from any UPS or FedEx in Bay County.",
  fpcOfficeDistance: "Serving Bay City, Essexville, Auburn, Linwood, Pinconning, Kawkawlin, Bangor Township, and all of Bay County and the Great Lakes Bay region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Bay City and the greater Bay County region. From the Saginaw Bay waterfront to the Lake Huron coastline, from Essexville to Pinconning — we serve all of the Great Lakes Bay corridor. The Detroit Passport Agency is approximately 115 miles southeast, and our couriers have direct access to it.",
  nearbyCitiesIntro: "We serve Bay City and all Bay County communities including Essexville, Auburn, Linwood, Pinconning, Kawkawlin, Bangor Township, Monitor Township, Frankenlust Township, Hampton Township, and Portsmouth Township. We also serve Great Lakes Bay travelers and MBS International Airport flyers.",
  howItWorksIntro: "Most Bay City travelers complete everything online and ship documents overnight. No driving 115 miles to the Detroit Passport Agency or waiting weeks for an appointment — our registered couriers handle the submission for you.",
  mistakesIntro: "Bay City is a unique Great Lakes Bay community with heavy Saginaw Bay tourism, Lake Huron coastal travel, and international family visits. Here are the most common passport mistakes we see from Bay County travelers.",
  testimonialsIntro: "Bay City travelers — from MBS International Airport flyers to Lake Huron boating enthusiasts to international families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Bay City, MI? Here are the most common ones we hear from Bay County and Great Lakes Bay travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for MBS Airport and Great Lakes Bay travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person in Detroit — 115-mile drive", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Bay City travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute MBS International Airport flights, family emergencies, and Lake Huron cruise travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "MBS Airport and Great Lakes Bay travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Bay City adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Bay County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Bay City residents and families — including international students, new citizens, and Great Lakes Bay families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Bay City residents who lost their passport before international travel or MBS Airport departure.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Bay City-area families planning international vacations, Lake Huron trips, or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Bay City and Bay County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Bay City MI", description: "Urgent passport processing for Bay City Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Bay City MI", description: "Fast passport renewal for Bay City Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Bay City MI", description: "New passport application services for Bay City Michigan residents applying for their first passport." },
    { name: "Child Passport Bay City MI", description: "Minor passport services for Bay City Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Stephanie M.",
      location: "Bay City, MI",
      rating: 5,
      text: "Flying out of MBS to Cancun in 5 days and my passport was expired. Fast Passport Center saved the trip — renewed in 3 days. I shipped from the UPS Store on Wilder Road and had it back before I even packed.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Michael T.",
      location: "Essexville, MI",
      rating: 5,
      text: "Business trip to Germany in 4 days and my passport was lost. Fast Passport Center had a replacement in my hands in 48 hours. No driving to Detroit, no appointment wait. Their courier service is a lifesaver for Bay County.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Rebecca K.",
      location: "Auburn, MI",
      rating: 5,
      text: "Family trip to Italy with 10 days notice. Five passports for our family. Fast Passport Center processed all of them in 5 days. They caught a mistake on one of my kid's forms that would have delayed us.",
      service: "Family Passport Bundle",
    },
    {
      name: "David H.",
      location: "Linwood, MI",
      rating: 5,
      text: "Cruise to the Caribbean and I realized my passport was expiring too soon. Fast Passport Center got me a renewed passport in 2 days. I shipped from the FedEx in Bay City and everything was seamless.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "bcity-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 115 miles southeast of Bay City — appointments typically booked 2 weeks out",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "bcity-2",
      name: "Bay City Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 1000 Washington Ave",
      city: "Bay City",
      state: "MI",
      zip: "48708",
      phone: "(989) 893-0074",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Bay City — near the Saginaw Bay waterfront",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Bay City acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Bay City and waterfront area residents.",
      icon: "ri-mail-line",
    },
    {
      id: "bcity-3",
      name: "West Bay City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 3600 Wilder Rd",
      city: "Bay City",
      state: "MI",
      zip: "48706",
      phone: "(989) 684-2701",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Bay City — near the Bay City Mall area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves west Bay City and Bangor Township residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "bcity-4",
      name: "Saginaw Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 123 N. Washington Ave",
      city: "Saginaw",
      state: "MI",
      zip: "48607",
      phone: "(989) 752-6341",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Saginaw — approximately 20 miles south of Bay City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Saginaw and southern Bay County residents. Larger facility with more appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "bcity-5",
      name: "Midland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 2900 Rodd St",
      city: "Midland",
      state: "MI",
      zip: "48640",
      phone: "(989) 631-2010",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Midland — approximately 30 miles west of Bay City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Midland and western Bay County residents. Book early during summer travel season.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Bay County" },
    { feature: "MBS Airport & Great Lakes Bay Expertise", agency: "No tailored advice", fpc: "Yes — MBS International Airport and Great Lakes Bay travel" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Bay City and Bay County travelers often discover passport issues right before MBS International Airport departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for International Air Travel",
      description: "Some Bay City-area travelers assume a passport card is sufficient for all travel — but passport cards are only valid for land and sea border crossings. All international flights require a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Bay County acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking MBS International Airport Flight Requirements",
      description: "MBS International Airport (Saginaw/Bay City/Midland) has limited international flight options. Many Bay City travelers connect through DTW or Chicago O'Hare. Verify passport requirements for all connecting airports.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Bay County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Bay City, Saginaw, or Midland." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no 115-mile drive or appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Bay County address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport agency to Bay City, MI?", a: "The Detroit Passport Agency is the nearest regional passport agency to Bay City, located at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 115 miles southeast. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access and can submit applications without individual appointments, saving you the long drive and wait." },
    { q: "How fast can I get an emergency passport in Bay City?", a: "Fast Passport Center offers emergency passport processing in Bay City, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to drive 115 miles southeast or take a day off work." },
    { q: "Do I need a passport for international flights from MBS International Airport?", a: "Yes. All international flights from MBS International Airport (Saginaw/Bay City/Midland) require a passport book. While MBS primarily serves domestic destinations, many Bay City travelers connect through Detroit Metro (DTW) or Chicago O'Hare for international flights. A passport book is required for all international air travel regardless of your departure airport." },
    { q: "Can I get an expedited passport in the Bay City suburbs like Essexville or Auburn?", a: "Absolutely. Fast Passport Center serves all of Bay County including Essexville, Auburn, Linwood, Pinconning, Kawkawlin, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Bay City-area travelers use for international flights?", a: "MBS International Airport (MBS) in Freeland is the local airport for Bay City, Saginaw, and Midland — primarily domestic flights with some connections. Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub — approximately 115 miles southeast. Many Bay City travelers also use Chicago O'Hare (ORD) for international connections. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Bay City, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Bay City-area residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Bay City, Essexville, and Saginaw offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve the Upper Peninsula from Bay City?", a: "Yes. Fast Passport Center serves all of Michigan including the Upper Peninsula. Our courier service is especially valuable for remote UP communities, which would otherwise face an 8+ hour drive to the Detroit Passport Agency. We serve Marquette, Sault Ste. Marie, Houghton, Escanaba, and all UP communities — you just ship your documents overnight and we handle everything from there." },
  ],
  photoLocations: [
    { name: "Walgreens — Wilder Road", address: "3600 Wilder Rd, Bay City, MI 48706", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Bay City", address: " 1015 S. Euclid Ave, Bay City, MI 48706", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Bay City", address: " 3921 Wilder Rd, Bay City, MI 48706", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Saginaw", address: " 4675 Bay Rd, Saginaw, MI 48604", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Bay City", address: " 1000 Washington Ave, Bay City, MI 48708", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Serves Bay City, Essexville, and central Bay County. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Saginaw", address: " 3030 Bay Rd, Saginaw, MI 48603", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Saginaw, Saginaw Township, and southern Bay County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "MBS",
      name: "MBS International Airport",
      distance: "Located in Freeland — approximately 15 miles south of Bay City",
      address: "8500 Garfield Rd, Freeland, MI 48623",
      note: "Regional airport serving Bay City, Saginaw, and Midland. Primarily domestic flights with connections to major hubs. Delta, United, and American service. Not a major international gateway — most Bay City international travelers connect through DTW or Chicago O'Hare.",
      flightUrl: "https://www.mbsairport.com/",
      flightLabel: "MBS Airport Info",
      featured: false,
    },
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "Approximately 115 miles southeast of Bay City via I-75",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for the Great Lakes Bay region. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan. Most Bay City international travelers connect through DTW.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
  ],
};